import React from 'react';
import { cn } from '../../lib/utils';

/**
 * PullQuote — citation magazine, à insérer en encart asymétrique.
 */
export const PullQuote = ({ children, author, className, ...props }) => (
  <figure
    className={cn('relative my-6 max-w-2xl', className)}
    data-testid="pull-quote"
    {...props}
  >
    <span
      aria-hidden="true"
      className="absolute -left-3 sm:-left-6 -top-4 text-7xl leading-none text-[hsl(var(--primary))]"
      style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
    >
      “
    </span>
    <blockquote
      className="editorial-quote text-xl sm:text-2xl leading-relaxed text-foreground/90"
      style={{ fontFamily: "'Crimson Text', Georgia, serif" }}
    >
      {children}
    </blockquote>
    {author && (
      <figcaption className="mt-3 editorial-kicker text-[10px] not-italic">
        — {author}
      </figcaption>
    )}
  </figure>
);

export default PullQuote;
